import { graphqlApolloClient } from "../graphql-apollo-client"
import { DELETE_MINISTRATION_PERIOD, UPDATE_MINISTRATION_PERIOD, UPDATE_MINISTRATION_PERIODS } from "./graphql"
import { GET_MINISTRATION_PERIODS } from "./graphql/get-ministration-periods"

export const ministrationPeriodService = () => {
  const getMinistrationPeriods = async ({ skip, first, filters = {} }) => {
    const { data } = await graphqlApolloClient.query({
      fetchPolicy: "network-only",
      query: GET_MINISTRATION_PERIODS,
      variables: {
        first,
        skip,
        endDate: filters.endDate,
        startDate: filters.startDate
      }
    })
    return {
      data: data?.getMinistrationPeriods,
      metadata: { count: data?.getMinistrationPeriodsMetadata }
    }
  }

  const updateMinistrationPeriod = async ({ ministrationPeriod, ministrationPeriodId }) => {
    if (!ministrationPeriodId) {
      throw new Error("Ministration period ID required")
    }
    const { data } = await graphqlApolloClient.mutate({
      mutation: UPDATE_MINISTRATION_PERIOD,
      variables: {
        ministrationPeriodId,
        ministrationPeriodData: ministrationPeriod
      }
    })
    return data?.UpdateMinistrationPeriod
  }

  const updateMinistrationPeriodsOrderIndex = async ({ ministrationPeriods }) => {
    const ministrationPeriodsIdAndOrderIndex = ministrationPeriods.map(({ id, orderIndex }) => ({
      id,
      orderIndex
    }))

    const { data } = await graphqlApolloClient.mutate({
      mutation: UPDATE_MINISTRATION_PERIODS,
      variables: {
        ministrationPeriodsData: ministrationPeriodsIdAndOrderIndex
      }
    })
    return data?.UpdateMinistrationPeriods
  }

  const deleteMinistrationPeriod = async ({ ministrationPeriodId }) => {
    if (!ministrationPeriodId) {
      throw new Error("Ministration period ID required")
    }
    const { data } = await graphqlApolloClient.mutate({
      mutation: DELETE_MINISTRATION_PERIOD,
      variables: {
        ministrationPeriodId
      }
    })
    return data?.DeleteMinistrationPeriodById
  }

  return {
    getMinistrationPeriods,
    updateMinistrationPeriod,
    deleteMinistrationPeriod,
    updateMinistrationPeriodsOrderIndex
  }
}
